module.exports = __webpack_public_path__ + "static/img/qualification2.ccb4123c.png";